import React, { useEffect, useState } from 'react';
import { Container, useTheme } from '@mui/material';
import Page from 'src/components/Page';
import { makeStyles } from 'tss-react/mui';
import { websiteTitle } from 'src/config';
import { useTranslation } from 'react-i18next';
import ApprovalsTable from './ApprovalsTable';
import useAuth from 'src/hooks/useAuth';
import GetPendingRequests from 'src/api/GetPendingRequests';
import usePendingRequests from 'src/hooks/usePendingRequests';
import { useSnackbar } from 'notistack';
import LoadingScreen from 'src/components/LoadingScreen';
import { orderBy } from "lodash";

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(0.5)
  },
  metalRoot: {
    backgroundColor: 'var(--neutral-1)',
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.up('md')]: {
      padding: `0 ${theme.spacing(6)} ${theme.spacing(0.5)}`
    }
  }
}));

const ApprovalsView = props => {
  const theme = useTheme();
  const { classes } = useStyles();
  const { t } = useTranslation();
  const pageTitle = websiteTitle + ' - ' + t('approvals');
  const { enqueueSnackbar } = useSnackbar();
  const { getAccessToken, loggedInUser } = useAuth();
  const { pendingRequests, handlePendingRequestsUpdate } = usePendingRequests();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    const initializeApprovals = async () => {
      const { tokenAvailable, accessToken } = await getAccessToken();
      if (!tokenAvailable) {
        console.log(accessToken);
      }
      const { success, data } = await GetPendingRequests(
        accessToken,
        loggedInUser.id
      );
      if (success) {
        handlePendingRequestsUpdate(data);
      } else {
        enqueueSnackbar(data, {
          variant: 'error'
        });
      }
      setLoading(false);
    };
    initializeApprovals();
  }, []);

  return (
    <Page
      className={classes.metalRoot}
      title={pageTitle}
    >
      <Container
        maxWidth={'xxl'}
        disableGutters
      >
        {pendingRequests.length > 0 ? orderBy(pendingRequests, [(g) => g.groupName, "id"], ["asc", "asc"]).map((groupRequests, index) => {
          return (
            <ApprovalsTable
              key={index}
              requestsList={groupRequests.requests}
              groupApprovalThreshold={groupRequests.groupApprovalThreshold}
              groupName={groupRequests.groupName}
              groupId={groupRequests.groupId}
              approvalsLoading={loading}
              {...props}
            />
          );
        }) : <LoadingScreen />}
      </Container>
    </Page>
  ) 
};

export default ApprovalsView;
